import { Col, Row } from "antd";
import { useBannerContext } from "../../../context/BannerContext/BannerContext";
import { BannerFormData } from "../../../context/BannerContext/constants";
import FileUploadComponent, { FileData } from "../../../components/FileUploadComponent";
import { FileUploadItems } from "./constants";


const BannerFiles = () => {
	const { setBannerForm } = useBannerContext();

	const handleFileChange = (files: FileData[] | null, key: keyof BannerFormData["images"]) => {
		setBannerForm(prevState => ({
			...prevState,
			images: {
				...prevState.images,
				[key]: files && files.length > 0 ? files[0].file : null,
			},
		}));
	};

	return (
		<>
			<Row gutter={20}>
				{FileUploadItems.map((item) => (
					<Col span={10} key={item.key}>
						<FileUploadComponent
							title={item.label}
							isRequired={item.isRequired}
							onChange={(fileData: FileData[] | null) => handleFileChange(fileData, item.key as keyof BannerFormData["images"])}
							dimensions={item.dimensions}
							maxFileSize={item.maxFileSize}
							allowedExtensions={item.extensions}
						/>
					</Col>
				))}
			</Row>
		</>
	);
};

export default BannerFiles;
